import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { onZefDialogClose, onZefDialogOpen, zefDialogClose, zefDialogOpen } from '@zerops/zef/dialog';
import { map, mergeMap } from 'rxjs/operators';
import { automaticTopUpConfigDialogActions } from './automatic-top-up-config-dialog.action';
import { FEATURE_NAME } from './automatic-top-up-config-dialog.constant';
import { AutomaticTopUpConfigDialogForm } from './automatic-top-up-config-dialog.form';
import { autoTopUpUpdateSuccess } from '@zerops/zerops/core/billing-base';

@Injectable()
export class AutomaticPaymentConfigDialogEffect {

  // # Deps
  #actions$ = inject(Actions);
  #form = inject(AutomaticTopUpConfigDialogForm);

  // # Effects
  onAutomaticPaymentConfigDialogOpen$ = createEffect(() => this.#actions$.pipe(
    ofType(automaticTopUpConfigDialogActions.open),
    map(({ data }) => zefDialogOpen({
      key: FEATURE_NAME,
      meta: data
    }))
  ));

  onDialogOpenSetForm$ = createEffect(() => this.#actions$.pipe(
    onZefDialogOpen(FEATURE_NAME),
    map(({ meta }) => {
      const autoTopUp = meta?.autoTopUp;
      return this.#form.setValue({
        enabled: !!autoTopUp,
        threshold: autoTopUp ? Number(autoTopUp.threshold) : undefined,
        amount: autoTopUp ? Number(autoTopUp.amount) : undefined,
        calendarMonthlyLimit: autoTopUp ? Number(autoTopUp.calendarMonthlyLimit) : undefined
      });
    })
  ));

  onAutoTopUpUpdateSuccess$ = createEffect(() => this.#actions$.pipe(
    ofType(autoTopUpUpdateSuccess),
    map(() => zefDialogClose({ key: FEATURE_NAME }))
  ));

  onAutomaticPaymentConfigDialogCloseResetForm$ = createEffect(() => this.#actions$.pipe(
    onZefDialogClose(FEATURE_NAME),
    mergeMap(() => [
      this.#form.reset(),
      this.#form.setDefaultValues()
    ])
  ));

}
